<template>
  <a-drawer
      :title="titleMap[field] || '详情'"
      :visible="visible"
      width="720"
      @close="closeDrawer"
  >
    <a-table
        row-key="id"
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        @change="handlePageChange"
        bordered
    />
  </a-drawer>
</template>

<script>
import { fetchTaskDetailList } from '@/api/statistics/task-welfare' // 分页列表接口

export default {
  props: {
    visible: Boolean,
    field: String,
    dateRange: Array
  },
  data() {
    return {
      taskTypeMap: {
        facebook: 1,
        youtube: 2,
        tiktok: 3,
        message: 4,
        like: 5
      },
      list: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      titleMap: {
        facebook: 'Facebook 关注用户',
        youtube: 'YouTube 关注用户',
        twitter: 'Twitter 关注用户',
        message: '打开消息通知用户',
        like: '设置爱好用户'
      },
      columns: [
        { title: '用户ID', dataIndex: 'userId', key: 'userId' },
        { title: '用户名称', dataIndex: 'userName', key: 'userName' },
        { title: '完成时间', dataIndex: 'timeStr', key: 'timeStr' }
      ]
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.fetchList()
      }
    },
    field() {
      this.pagination.current = 1
    }
  },
  methods: {
    closeDrawer() {
      this.$emit('update:visible', false)
    },
    fetchList() {
      const [start, end] = this.dateRange
      const taskType = this.taskTypeMap[this.field]

      if (!taskType) return

      this.loading = true
      fetchTaskDetailList({
        taskType,
        startDate: start.format('YYYY-MM-DD'),
        endDate: end.format('YYYY-MM-DD'),
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      }).then(res => {
        this.list = res.data.records || []
        this.pagination.total = res.data.total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    handlePageChange(pagination) {
      this.pagination.current = pagination.current
      this.fetchList()
    }
  }
}
</script>
